import * as mapping from "knockout.mapping";
import * as ko from "knockout";
import * as $ from "jquery";
import { Address } from "../../Models/NewspaperRequestModels/address";
import { Topic } from "../../Models/NewspaperRequestModels/topic";
import { Newspaper } from "../../Models/NewspaperRequestModels/newspaper";
import { Period } from "../../Models/NewspaperRequestModels/period";
import { SubscriptionDataModel } from "../../Models/NewspaperRequestModels/subscriptionDataModel";
import { Status } from "../../Models/NewspaperRequestModels/status";
import { KnockoutHelper } from "../../knockoutHelper";


class SubscriptionPageViewModel {
    dataFromServer: any;
    dropdownsOptions: any;
    dataTablesExcelExportButtonOptions: any;
    dataTablesLanguageOptions: any;

    constructor(params: any) {
        let mappingOptionsForDropdownsOptions = {
            'addresses': {
                create: (args: any) => {
                    return new Address(args.data);
                }
            },
            'newspapers': {
                create: (args: any) => {
                    return new Newspaper(args.data);
                }
            },
            'periods': {
                create: (args: any) => {
                    return new Period(args.data);
                }
            },
            'statuses': {
                create: (args: any) => {
                    return new Status(args.data);
                }
            }
        }
        this.dropdownsOptions = mapping.fromJS(params.dropdownsOptions, mappingOptionsForDropdownsOptions);

        this.dataFromServer = ko.observableArray<SubscriptionDataModel>();

        let organizationName = $("#organizationName :selected").text();

        this.dataTablesExcelExportButtonOptions = {
            extend: 'excelHtml5',
            customize: (xlsx: any) => {
                let sheet = xlsx.xl.worksheets['sheet1.xml'];
                $('c[r=A1] t', sheet).text(organizationName);
            }
        };

        this.dataTablesLanguageOptions = {
            processing: "Feldolgozás...",
            search: "_INPUT_ <i class='fas fa-search'></i>",
            searchPlaceholder: "Keresés...",
            lengthMenu: "_MENU_ találat oldalanként",
            info: "Találatok: _START_ - _END_ Összesen: _TOTAL_",
            infoEmpty: "Nulla találat",
            infoFiltered: "(_MAX_ összes rekord közül szűrve)",
            infoPostFix: "",
            loadingRecords: "Betöltés...",
            zeroRecords: "Nincs a keresésnek megfelelő találat",
            emptyTable: "Nincs rendelkezésre álló adat",
            paginate: {
                first: "Első",
                previous: "Előző",
                next: "Következő",
                last: "Utolsó"
            },
            aria: {
                sortAscending: ": aktiválja a növekvő rendezéshez",
                sortDescending: ": aktiválja a csökkenő rendezéshez"
            }
        }

        let dataTablesOptions = {
            buttons: [
                this.dataTablesExcelExportButtonOptions
            ],
            language: this.dataTablesLanguageOptions,
            initComplete: () => {
                $("div.dataTables_length select").removeClass("custom-select custom-select-sm");
            }
        };
        KnockoutHelper.initDataTablesWithExcelButton("data-table", dataTablesOptions);
    }
}

export class SubscriptionPageComponent {
    constructor() {
        return {
            viewModel: SubscriptionPageViewModel,
            template: require("text-loader!./subscriptionPageView.html")
        }
    }
}